import {
  TabPanels as HuiTabPanels,
  TabPanelsProps as HuiTabPanelsProps,
} from '@headlessui/react';
import { FC } from 'react';

export type TabPanelsProps = HuiTabPanelsProps;

export const TabPanels: FC<TabPanelsProps> = ({ children, ...props }) => (
  <HuiTabPanels {...props}>{children}</HuiTabPanels>
);
